import HistoryIntro from '~/pages/history/intro/libs/components/History'
import { TPageProps } from '~/shared/types/commonTypes'

const IntroHistory = ({ nextPagePath }: TPageProps) => (
  <HistoryIntro nextPagePath={nextPagePath} />
)

export default IntroHistory
